import React from 'react';
import x_icon_cancel from '../../../../icons/x_icon_cancel.svg';

const HowUniquePopup = ({ textColor, item, onClose }) => {
    return (
        <div className="how-unique__card">
            {/* Close button wrapper; triggers onClose when clicked */}
            <div className='close-btn__wrapper' onClick={onClose}>
                <span>
                    <img className="x_icon_cancel" src={x_icon_cancel} alt="close" />
                </span>
            </div>
            
            {/* Icon display section for the item */}
            <div className='how-unique__card-icon-box'>
                <img className="how-unique__card-icon" src={item.icon} alt="icon" />
            </div>
            
            {/* Title of the popup, dynamically populated from item prop */}
            <h1 className="how-unique__card-title" style={{color: textColor}}>{item.title}</h1>
            
            {/* Description, allowing HTML content from item.desc safely */}
            <p className='how-unique__card-desc' dangerouslySetInnerHTML={{ __html: item.desc }}></p>
        </div>
    );
};

export default HowUniquePopup;
